// extracted by mini-css-extract-plugin
module.exports = {"background":"styles_background__1kf7U","header":"styles_header__1XXqb","nav":"styles_nav__1tfda","line":"styles_line__3hbGL"};